<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

      <WiringEditComponent/>

    </transition>
  </div>
</template>

<script>

import WiringEditComponent from '@/components/LettersEditComponent.vue'

export default {
  name: 'Wiring',
  components: {
    WiringEditComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>